import React, { Component } from "react";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//icons
import { FiPlus } from "react-icons/fi";
import stages from "../../../../images/icon/stages.png";

import "../../../../styles/Tournaments.css";
import TournamentHeader from "../common/TournamentHeader";
import { IoInformationCircleOutline } from "react-icons/io5";
import {
  errorHandler,
  getMatchesStructure,
  getTournamentData,
  getWebData,
  is_Natural,
  PlayoffFormats,
} from "../../../../utils/common.utils";
import TournamentApis from "../../../../helper/tournament.api";
import { toast } from "react-toastify";

import { AiFillDelete, AiOutlineCheck } from "react-icons/ai";
import { Modal } from "react-bootstrap";
import ConfirmationModal from "../../../popup/ConfirmationModal";
import { isPrime, validateMaxParticipant } from "../../../../utils/Validations";
import { number } from "yup";
import { LABEL, PLACEHOLDER, WARNING } from "../../../../utils/Strings.utils";
import ReactTooltip from "react-tooltip";
import { BsInfoCircle } from "react-icons/bs";
import { WEBSITE_ENUM } from "../../../../utils/enums.utils";

export default class FSingleElimination extends Component {
  constructor(props) {
    super(props);
    const queryParams = new URLSearchParams(window.location.search);
    let localData = JSON.parse(localStorage.getItem("ffa-single-elimination"));

    this.state = {
      tournamentDetails: null,
      openConfirmationModal: false,
      openEditConfirmationModal: false,
      maxParticipants:
        !queryParams.get("isUpdate") &&
        localData?.maxParticipants &&
        localData?.tournamentId === props.match.params.id
          ? localData.maxParticipants
          : "",
      maxParticipantsPerMatch:
        !queryParams.get("isUpdate") &&
        localData?.maxParticipantsPerMatch &&
        localData?.tournamentId === props.match.params.id
          ? localData.maxParticipantsPerMatch
          : "",
      winnersPerMatch:
        !queryParams.get("isUpdate") &&
        localData?.winnersPerMatch &&
        localData?.tournamentId === props.match.params.id
          ? localData.winnersPerMatch
          : "",
      threshold:
        !queryParams.get("isUpdate") &&
        localData?.threshold &&
        localData?.tournamentId === props.match.params.id
          ? localData.threshold
          : "",
      updatedMatches: false,
      stageName:
        !queryParams.get("isUpdate") &&
        localData?.stageName &&
        localData?.tournamentId === props.match.params.id
          ? localData.stageName
          : "",
      minParticipant: null,
      playoffFormat:
        !queryParams.get("isUpdate") &&
        localData?.playoffFormat &&
        localData?.tournamentId === props.match.params.id
          ? localData.playoffFormat
          : 1,
    };
    this.localObject = {
      maxParticipants:
        !queryParams.get("isUpdate") &&
        localData?.maxParticipants &&
        localData?.tournamentId === props.match.params.id
          ? localData.maxParticipants
          : "",
      maxParticipantsPerMatch:
        !queryParams.get("isUpdate") &&
        localData?.maxParticipantsPerMatch &&
        localData?.tournamentId === props.match.params.id
          ? localData.maxParticipantsPerMatch
          : "",
      winnersPerMatch:
        !queryParams.get("isUpdate") &&
        localData?.winnersPerMatch &&
        localData?.tournamentId === props.match.params.id
          ? localData.winnersPerMatch
          : "",
      threshold:
        !queryParams.get("isUpdate") &&
        localData?.threshold &&
        localData?.tournamentId === props.match.params.id
          ? localData.threshold
          : "",
      stageName:
        !queryParams.get("isUpdate") &&
        localData?.stageName &&
        localData?.tournamentId === props.match.params.id
          ? localData.stageName
          : "",
      playoffFormat:
        !queryParams.get("isUpdate") &&
        localData?.playoffFormat &&
        localData?.tournamentId === props.match.params.id
          ? localData.playoffFormat
          : 1,
      tournamentId: this.props.match.params.id,
    };
    this.props.updateLoader(true);
    getTournamentData(this.props.match.params.id, this.setData);

    this.tournament = new TournamentApis();

    this.isUpdate = queryParams.get("isUpdate");
    this.index = queryParams.get("index");
    this.editIsUpdate = false;
    this.editStages = [];
    this.isValuesChanged = false;
    this.currentStages = null;
  }
  componentDidMount() {
    this.props.showOrHideNav(true);
  }
  // when data not came from location.state it returns data from API
  setData = values => {
    if (values) {
      this.setState({
        tournamentDetails: values,
        maxParticipants: values.stages[this.index]?.maxParticipants
          ? values.stages[this.index]?.maxParticipants
          : this.state.maxParticipants,
        maxParticipantsPerMatch: values.stages[this.index]?.maxParticipantsPerMatch
          ? values.stages[this.index]?.maxParticipantsPerMatch
          : this.state.maxParticipantsPerMatch,
        winnersPerMatch: values.stages[this.index]?.winnersPerMatch
          ? values.stages[this.index]?.winnersPerMatch
          : this.state.winnersPerMatch,
        threshold: values.stages[this.index]?.qualificationThreshold
          ? values.stages[this.index]?.qualificationThreshold
          : this.state.threshold,
        stageName: values.stages[this.index]?.name
          ? values.stages[this.index]?.name
          : this.state.stageName,
        playoffFormat: values.stages[this.index]?.playoffFormat
          ? values.stages[this.index].playoffFormat
          : this.state.playoffFormat,
        minParticipant: values?.stages?.length
          ? values?.stages[
              values?.stages?.length > 1 && this.isUpdate
                ? values?.stages?.length - 2
                : values?.stages?.length - 1
            ].qualificationThreshold
          : null,
      });
      this.props.updateLoader(false);
    } else {
      this.props.updateLoader(false);
      this.props.history.push("/pageNotFound");
    }
  };
  onSubmit = values => {
    var isUpdate;
    if (this.isUpdate === null) {
      isUpdate = false;
    } else {
      isUpdate = true;
    }

    var stage = {
      level: isUpdate
        ? this.currentStages[this.index].level
        : this.state.tournamentDetails?.stages?.length + 1,
      name: values.stageName,
      type: "FFA",
      subType: "Single Elimination",
      path: "ffa-single-elimination",
      status: "UPCOMING",
      maxParticipants: parseInt(values.maxParticipant),
      maxParticipantsPerMatch: parseInt(values.maxParticipantsPerMatch),
      winnersPerMatch: parseInt(values.winnersPerMatch),
      // includeThirdPlace: (values.thirdPlaceChecked ? values.thirdPlaceChecked : false),
      qualificationThreshold: parseInt(values.qualificationThreshold),
      playoffFormat: values.playoffFormat ? parseInt(values.playoffFormat) : 1,
    };

    if (isUpdate && !this.state.updatedMatches) {
      stage.groups = this.currentStages[this.index].groups;
    } else {
      stage.groups = getMatchesStructure(stage, 5);
    }

    this.editIsUpdate = isUpdate;
    this.editStages = [stage];
    let previousStageData = this.state.tournamentDetails?.stages[this.index];
    if (isUpdate) {
      if (
        previousStageData.name !== values.stageName ||
        previousStageData.maxParticipants !== values.maxParticipant ||
        previousStageData.maxParticipantsPerMatch !== values.maxParticipantsPerMatch ||
        previousStageData.winnersPerMatch !== values.winnersPerMatch ||
        previousStageData.qualificationThreshold !== values.qualificationThreshold ||
        previousStageData.playoffFormat !== stage.playoffFormat
      ) {
        this.isValuesChanged = true;
      }
    }

    if (
      isUpdate &&
      parseInt(this.index) !== parseInt(this.state.tournamentDetails?.stages.length - 1) &&
      this.isValuesChanged
    ) {
      this.setState({ openEditConfirmationModal: true });
    } else {
      // if (this.isValuesChanged) {
      this.addOrUpdate([stage], isUpdate);
      // }
    }
  };
  addOrUpdate = (stages, isUpdate) => {
    if (this.state.tournamentDetails?.participantUserId?.length && this.isUpdate) {
      toast.error("Cannot update the stage after participants added in tournament");
    } else {
      this.props.updateLoader(true);
      this.tournament
        .addOrUpdateStage(this.props.match?.params?.id, stages, isUpdate)
        .then(res => {
          this.props.updateLoader(false);
          if (isUpdate) {
            this.props.history.push(
              `/organization/${res.data.result.organizationId}/tournament/${res.data.result._id}/overview/structure`
            );
            toast.success(`Stage updated successfully`);
          } else {
            localStorage.removeItem("ffa-single-elimination");
            var index =
              this.state.tournamentDetails?.stages?.length === 0
                ? 0
                : this.state.tournamentDetails?.stages?.length;
            this.props.history.push(
              `/organization/${res.data.result.organizationId}/tournament/${res.data.result._id}/overview/structure/tournament-stages/${index}/slot-details/0`
            );
            toast.success(`Stage created successfully`);
          }
        })
        .catch(reason => {
          this.props.updateLoader(false);
          errorHandler(reason);
        });
    }
  };
  deleteStage = index => {
    var data = {
      tournamentId: this.props.match?.params?.id,
      stage: index,
    };
    // var stages = this.state.tournamentDetails.stages;
    // stages.splice(index, 1);
    // this.update(stages,"deleted");
    this.props.updateLoader(true);
    this.tournament
      .deleteStage(data)
      .then(res => {
        this.props.updateLoader(false);
        this.props.history.push({
          pathname: `/organization/${res.data.result.organizationId}/tournament/${res.data.result._id}/overview/structure`,
          state: {
            orgId: res.data.result.organizationId,
            tournamentDetails: res.data.result,
          },
        });
        toast.success(`Stage ${parseInt(index) + 1} deleted successfully`);
      })
      .catch(reason => {
        this.props.updateLoader(false);
        errorHandler(reason);
      });
  };
  //open confirmation popup
  onClickOpenConfirm = () => {
    this.setState({
      openConfirmationModal: !this.state.openConfirmationModal,
    });
  };
  updateQuantity = (e, key) => {
    e.preventDefault();
    if (!this.isUpdate) {
      this.localObject[key] = e.target.value;
      localStorage.setItem("ffa-single-elimination", JSON.stringify(this.localObject));
    }
    this.setState({
      [key]: e.target.value,
      updatedMatches: true,
    });
  };
  maxParticipantValidation = e => {
    let error;
    let number = parseFloat(e);
    if (!is_Natural(number)) {
      error = `Invalid input value`;
    } else if (!validateMaxParticipant(this.state.tournamentDetails?.maxParticipant, e)) {
      error = `Max participant should be less than ${this.state.tournamentDetails?.maxParticipant}`;
    } else if (isPrime(e)) {
      error = `Max participants should not be a prime number`;
    }
    if (this.index !== "0") {
      if (number < this.state.minParticipant) {
        error = `Max participants should not be less than ${this.state.minParticipant}`;
      }
    }
    return error;
  };
  participantPerMatchValidation = e => {
    let error;
    let number = parseFloat(e);
    if (this.state.maxParticipants && e) {
      if (!is_Natural(number)) {
        error = `Invalid input value`;
      } else if (this.state.maxParticipants % e !== 0) {
        const participantType =
          this.state.tournamentDetails?.participantType === "TEAM" ? "Teams" : "Participants";
        error = `${participantType} per match must be a factor of max ${participantType.toLowerCase()}`;
      } else if (number < 3) {
        const participantType =
          this.state.tournamentDetails?.participantType === "TEAM" ? "Team" : "Participant";
        error = `${participantType} per match should be more than 2`;
      }
    }
    return error;
  };
  winnerPerMatchValidation = e => {
    let error;
    let number = parseFloat(e);
    if (this.state.maxParticipantsPerMatch && e) {
      if (!is_Natural(number)) {
        error = `Invalid input value`;
      } else if (e < 1) {
        error = `Minimum winner per match should be 1`;
      } else if (e >= parseInt(this.state.maxParticipantsPerMatch)) {
        error = `Number of winner per match should be less than ${this.state.maxParticipantsPerMatch}`;
      }
    }
    return error;
  };
  thresholdValidation = async e => {
    let error;
    let number = parseFloat(e);
    if (
      this.state.winnersPerMatch !== this.state.maxParticipantsPerMatch &&
      this.state.winnersPerMatch &&
      this.state.maxParticipants &&
      this.state.maxParticipantsPerMatch &&
      e
    ) {
      let result =
        (this.state.maxParticipants / this.state.maxParticipantsPerMatch) *
        this.state.winnersPerMatch;
      if (!is_Natural(number)) {
        error = `Invalid input value`;
      } else if (result % this.state.maxParticipantsPerMatch === 0) {
        let possibleThresholds = [];
        let tempMaxParticipant = this.state.maxParticipants;
        let tempResult =
          (tempMaxParticipant / this.state.maxParticipantsPerMatch) * this.state.winnersPerMatch;
        while (tempMaxParticipant % this.state.maxParticipantsPerMatch === 0) {
          possibleThresholds.push(tempResult);
          tempMaxParticipant =
            (tempMaxParticipant / this.state.maxParticipantsPerMatch) * this.state.winnersPerMatch;
          tempResult =
            (tempMaxParticipant / this.state.maxParticipantsPerMatch) * this.state.winnersPerMatch;
        }

        let numbers = "";
        possibleThresholds.map((el, i) => {
          if (i + 1 === possibleThresholds.length) {
            numbers = numbers + el;
          } else {
            numbers = numbers + el + ",";
          }
        });

        if (!possibleThresholds.includes(number)) {
          error = `Threshold should be one of ${numbers}.`;
        }
      } else if (
        (this.state.maxParticipants / this.state.maxParticipantsPerMatch) *
          this.state.winnersPerMatch !==
        number
      ) {
        error = `Threshold should be ${(this.state.maxParticipants / this.state.maxParticipantsPerMatch) * this.state.winnersPerMatch}`;
      }
    }
    return error;
  };

  showToolTip = (id, place = "top", type = "warning", text) => {
    return (
      <ReactTooltip id={id} place={place} effect="solid" type={type}>
        {text}
      </ReactTooltip>
    );
  };

  render() {
    this.currentStages = this.state.tournamentDetails ? this.state.tournamentDetails.stages : false;
    const isUpdated = this.isUpdate && this.currentStages ? true : false;
    let type = this.state.tournamentDetails?.participantType === "TEAM" ? "Teams" : "Participants";

    const requiredObject = getWebData();

    const initials = {
      stageName: this.state.stageName,
      maxParticipant: this.state.maxParticipants,
      maxParticipantsPerMatch: this.state.maxParticipantsPerMatch,
      winnersPerMatch: this.state.winnersPerMatch,
      qualificationThreshold: this.state.threshold,
      playoffFormat: this.state.playoffFormat,
    };

    return (
      <section className="body-section ffa-single-elimination tooltip-text">
        <div className="container p-3 mt-lg-3">
          <TournamentHeader
            tournamentDetails={this.state.tournamentDetails}
            logo={stages}
            heading={`${isUpdated ? "Update" : "Add"} Stage Details`}
            subHeading={
              <h1 className="stage-sub-heading text-center">( FFA Single Elimination )</h1>
            }
            history={this.props.history}
          />

          <Formik
            enableReinitialize
            initialValues={initials}
            validationSchema={Yup.object({
              stageName: Yup.string()
                .required("*Stage name is required")
                .max(30, "Max 30 characters"),
              maxParticipant: Yup.number().required("Max participants required"),
              qualificationThreshold: Yup.number().required("*Threshold required"),
              winnersPerMatch: Yup.number()
                .required("*Winner per match required")
                .min(1, "Winner per match should be 1 or more than 1"),
              maxParticipantsPerMatch: Yup.number().required(
                this.state.tournamentDetails?.participantType === "TEAM"
                  ? "*Teams per match required"
                  : "*Participant per match required"
              ),
            })}
            onSubmit={(values, { setSubmitting }) => {
              setTimeout(() => {
                this.onSubmit(values);
                setSubmitting(false);
              }, 400);
            }}
          >
            <Form className="row f-single-elimination-form m-1 mt-lg-5" autoComplete="off">
              <div className="col-lg-6 col-md-6 col-12">
                <label htmlFor="stageName" className="fs-14 fw-600 text-white mb-1 mt-2 mt-lg-3">
                  Stage Name
                </label>
                <Field
                  name="stageName"
                  type="text"
                  className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                  placeholder="Enter Stage Name"
                  onKeyUp={e => this.updateQuantity(e, "stageName")}
                />
                <ErrorMessage component="span" className="error-msg" name="stageName" />
              </div>

              <div className="col-lg-6 col-md-6 col-12">
                <label
                  htmlFor="maxParticipant"
                  className="fs-14 fw-600 text-white mb-1 mt-2 mt-lg-3"
                >
                  Max {type}
                </label>

                <a
                  href="#"
                  title="Maximum No. of Participants that can Participate in Tournament or Stage"
                  className="tooltip-info"
                >
                  <BsInfoCircle className="text-white btn-size-12 ms-1 mt-2" />
                </a>
                <Field
                  name="maxParticipant"
                  type="number"
                  className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                  placeholder="Enter Max Participants"
                  validate={this.maxParticipantValidation}
                  onKeyUp={e => this.updateQuantity(e, "maxParticipants")}
                  min={1}
                  step={1}
                  onWheel={e => e.target.blur()}
                />
                <ErrorMessage component="span" className="error-msg" name="maxParticipant" />
              </div>

              <div className="col-lg-6 col-md-6 col-12">
                <label
                  htmlFor="maxParticipantsPerMatch"
                  className="fs-14 fw-600 text-white mb-1 mt-2 mt-lg-3"
                >
                  {this.state.tournamentDetails?.participantType === "TEAM"
                    ? LABEL.TEAMS_PER_MATCH
                    : LABEL.PARTICIPANTS_PER_MATCH}
                </label>

                <a
                  href="#"
                  title={
                    this.state.tournamentDetails?.participantType === "TEAM"
                      ? "It is Maximum No. of Teams that can participate in a Match."
                      : "It is Maximum No. of Participants that can participate in a Match."
                  }
                  className="tooltip-info"
                >
                  <BsInfoCircle className="text-white btn-size-12 ms-1 mt-2" />
                </a>
                <Field
                  name="maxParticipantsPerMatch"
                  type="number"
                  className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                  placeholder={
                    this.state.tournamentDetails?.participantType === "TEAM"
                      ? PLACEHOLDER.TEAMS_PER_MATCH
                      : PLACEHOLDER.PARTICIPANTS_PER_MATCH
                  }
                  validate={this.participantPerMatchValidation}
                  onKeyUp={e => this.updateQuantity(e, "maxParticipantsPerMatch")}
                  min={1}
                  step={1}
                  onWheel={e => e.target.blur()}
                />
                <ErrorMessage
                  component="span"
                  className="error-msg"
                  name="maxParticipantsPerMatch"
                />
              </div>

              <div className="col-lg-6 col-md-6 col-12">
                <label
                  htmlFor="winnersPerMatch"
                  className="fs-14 fw-600 text-white mb-1 mt-2 mt-lg-3"
                >
                  {LABEL.WINNERS_PER_MATCH}
                </label>

                <a
                  href="#"
                  title="It is the No. of winners Per Match that would head to Next Stage."
                  className="tooltip-info"
                >
                  <BsInfoCircle className="text-white btn-size-12 ms-1 mt-2" />
                </a>
                <Field
                  name="winnersPerMatch"
                  type="number"
                  className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                  placeholder={PLACEHOLDER.WINNERS_PER_MATCH}
                  validate={this.winnerPerMatchValidation}
                  onKeyUp={e => this.updateQuantity(e, "winnersPerMatch")}
                  min={1}
                  step={1}
                  onWheel={e => e.target.blur()}
                />
                <ErrorMessage component="span" className="error-msg" name="winnersPerMatch" />
              </div>

              <div className="col-lg-6 col-md-6 col-12">
                <label
                  htmlFor="qualificationThreshold"
                  className="fs-14 fw-600 text-white mb-1 mt-2 mt-lg-3"
                >
                  {LABEL.QUALIFICATION_THRESHOLD}
                </label>

                <a
                  href="#"
                  title={requiredObject.INFORMATION_TEXT?.STAGE_DETAILS?.QUALIFICATION_THRESHOLD}
                  className="tooltip-info"
                >
                  <BsInfoCircle className="text-white btn-size-12 ms-1 mt-2" />
                </a>
                <Field
                  name="qualificationThreshold"
                  type="number"
                  className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                  placeholder={PLACEHOLDER.QUALIFICATION_THRESHOLD}
                  validate={this.thresholdValidation}
                  onKeyUp={e => this.updateQuantity(e, "threshold")}
                  min={1}
                  step={1}
                  onWheel={e => e.target.blur()}
                />
                <ErrorMessage
                  component="span"
                  className="error-msg"
                  name="qualificationThreshold"
                />
              </div>

              <div className="col-lg-6 col-md-6 col-12">
                <label
                  htmlFor="playoffFormat"
                  className="fs-14 fw-600 text-white mb-1 mt-2 mt-lg-3"
                >
                  Playoff Format
                </label>
                {/* PLAY_OFF_FORMAT */}
                <a
                  href="#"
                  title={requiredObject.INFORMATION_TEXT?.STAGE_DETAILS?.PLAY_OFF_FORMAT}
                  className="tooltip-info"
                >
                  <BsInfoCircle className="text-white btn-size-12 ms-1 mt-2" />
                </a>
                <Field
                  value={this.state.playoffFormat}
                  onChange={e => this.updateQuantity(e, "playoffFormat")}
                  name="playoffFormat"
                  as="select"
                  id="playOff"
                  className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                >
                  {Object.keys(PlayoffFormats).map(function (key, i) {
                    return (
                      <option key={i} value={PlayoffFormats[key]}>
                        {key}
                      </option>
                    );
                  })}
                </Field>
                <ErrorMessage component="span" className="error-msg" name="playoffFormat" />
              </div>

              <div className="mt-5 d-flex justify-content-center">
                {isUpdated ? (
                  <div className="d-flex justify-content-center">
                    <div className="d-flex flex-column align-items-center me-6">
                      <button
                        type="submit"
                        className="round-btn rounded-circle d-flex align-items-center justify-content-center border-0 mx-4 btn-size-45"
                      >
                        <AiOutlineCheck className="fs-24" />
                      </button>
                      <span className="fw-bold text-white mt-2">Save Changes</span>
                    </div>
                    <div className="d-flex flex-column align-items-center">
                      <button
                        type="button"
                        onClick={e => this.onClickOpenConfirm(e)}
                        className="round-btn rounded-circle d-flex align-items-center justify-content-center border-0 mx-4 btn-size-45"
                      >
                        <AiFillDelete className="fs-24" />
                      </button>
                      <span className="fw-bold text-white mt-2">Delete Structure</span>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex flex-column align-items-center">
                    <button
                      type="submit"
                      className="round-btn rounded-circle d-flex align-items-center justify-content-center border-0 btn-size-45"
                    >
                      <FiPlus className="fs-24" />
                    </button>
                    <span className="fw-bold text-white mt-2">Save Structure</span>
                  </div>
                )}
              </div>
            </Form>
          </Formik>
        </div>
        <Modal
          show={this.state.openConfirmationModal}
          centered
          dialogClassName="Confirmation-modal"
        >
          <Modal.Body>
            <ConfirmationModal
              confirm={{
                msg:
                  parseInt(this.index) ===
                  parseInt(this.state.tournamentDetails?.stages.length - 1) ? (
                    <p className="fs-14 fw-600 text-center text-white-50">
                      Are you sure you want to remove{" "}
                      <span className="error-msg">
                        {isUpdated ? this.currentStages[this.index]?.name : ""}
                      </span>{" "}
                      from the stages ?
                    </p>
                  ) : (
                    <p className="fs-14 fw-600 text-center text-white-50">
                      Next stages will be deleted on delete of{" "}
                      <span className="error-msg">
                        {isUpdated ? this.currentStages[this.index]?.name : ""}
                      </span>{" "}
                      stage. Are you sure you want to edit this stage?
                    </p>
                  ),
                key: isUpdated ? this.index : null,
              }}
              onClickOpenConfirm={this.onClickOpenConfirm}
              confirmed={this.deleteStage}
            />
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.openEditConfirmationModal}
          centered
          dialogClassName="Confirmation-modal"
        >
          <Modal.Body>
            <ConfirmationModal
              confirm={{
                msg: (
                  <p className="fs-14 fw-600 text-center text-white-50">
                    {WARNING.NEXT_STAGE_WILL_BE_DELETED}
                  </p>
                ),
                key: isUpdated ? this.index : null,
              }}
              onClickOpenConfirm={() => {
                this.setState({ openEditConfirmationModal: false });
              }}
              confirmed={() => {
                this.addOrUpdate(this.editStages, this.editIsUpdate);
              }}
            />
          </Modal.Body>
        </Modal>
      </section>
    );
  }
}
